<template>
  <el-menu @select="handleSelect">
    <el-submenu index="1">
      <template slot="title"><i class="el-icon-s-check"></i>内容审核</template>
      <el-menu-item index="release">发布审核</el-menu-item>
      <el-menu-item index="report">举报审核</el-menu-item>
    </el-submenu>
    <el-submenu index="2">
      <template slot="title"><i class="el-icon-setting"></i>系统设置</template>
      <el-menu-item index="2-1">用户设置</el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import Bus from "../api/Bus";
export default {
  name: "Aside",
  data() {
    return {
      status: "0"
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      if (key == "release") {
        this.status = "1";
      } else if (key == "report") {
        this.status = "3";
      }
      Bus.$emit("asideStatus", this.status);
    }
  }
};
</script>

<style>
/**二级标题背景颜色 */
.el-menu {
  background-color: #252222;
}

/**一级标题颜色 */
.el-submenu__title {
  color: #ffdd1a !important;
}
/**未选中得颜色 */
.el-menu-item {
  color: #ddd;
}
.el-submenu__title:hover,
.el-menu-item.is-active,
.el-menu-item:focus,
.el-menu-item:hover {
  color: #4766ff;
}
</style>



// WEBPACK FOOTER //
// src/views/dhome/DAside.vue